import { forwardRef, useId } from 'react'
import type { InputHTMLAttributes } from 'react'
import { FileUp } from 'lucide-react'
import { FieldFeedback } from '../Field/FieldFeedback'
import { resolveFieldFeedback } from '../Field/field-feedback'
import type { FieldStatus } from '../Field/field-feedback'
import {
  copy,
  dropzone,
  fileName,
  helper,
  icon,
  input,
  label as labelClass,
  root,
  title,
} from './FileDropzone.css'

export type FileDropzoneProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value'> & {
  label: string
  helperText?: string
  error?: string
  status?: FieldStatus
  message?: string
  file?: File | null
}

export const FileDropzone = forwardRef<HTMLInputElement, FileDropzoneProps>(function FileDropzone(
  {
    label,
    helperText,
    error,
    status,
    message,
    file,
    id,
    disabled = false,
    accept = 'image/png,image/jpeg,application/pdf',
    ...rest
  },
  ref,
) {
  const generatedId = useId()
  const inputId = id ?? generatedId
  const feedbackId = `${inputId}-feedback`
  const feedback = resolveFieldFeedback({ error, helperText, message, status })

  return (
    <div className={root}>
      <span className={labelClass}>{label}</span>
      <label className={dropzone({ invalid: feedback.invalid, disabled })} htmlFor={inputId}>
        <span className={icon}>
          <FileUp size={20} />
        </span>
        <span className={copy}>
          <span className={title}>{file ? 'Arquivo selecionado' : 'Selecionar arquivo'}</span>
          {file ? <span className={fileName}>{file.name}</span> : null}
          {helperText && !feedback.message ? <span className={helper}>{helperText}</span> : null}
        </span>
        <input
          {...rest}
          ref={ref}
          id={inputId}
          type="file"
          accept={accept}
          disabled={disabled}
          className={input}
          aria-invalid={feedback.invalid}
          aria-describedby={feedback.message ? feedbackId : rest['aria-describedby']}
        />
      </label>
      <FieldFeedback id={feedbackId} status={feedback.status}>
        {feedback.message}
      </FieldFeedback>
    </div>
  )
})
